// LUCKY DUCKY · PHASE 2 · Verified Cardinal Paytable + Wild + BONUS scatter
// Source of truth: spec/verified_paytable.json
// Hash (SHA-256): e38b16644b8fe23e6ab7a2f576892514efe98411d030de6e1b2a63672720352a
//
// LOCKED rules (from verified_paytable.json + Phase 2 message):
//   · WILD substitutes for all symbols except BONUS.
//   · 1 or 2 Wilds on a winning payline pay the standard line win × 2.
//   · 3/4/5 Wilds forming their own consecutive line use DOUBLE_WILD_standalone.
//   · BONUS is scatter — evaluated over the visible 5×3 grid, not by payline.
//   · Feature (BETO RESPINS) wins pay 3×.
//
// NEEDS_VERIFICATION (do NOT resolve without a new Cardinal directive):
//   · mixed_3plus_wild_standard — mixed lines with ≥3 Wilds + at least one
//     standard symbol.  The engine does NOT pay these lines; it counts them
//     into simulator telemetry as `mixed_3plus_wild_flagged`.
import verified from '../spec/verified_paytable.json';

export const DENOMINATION_CENTS  = verified.denomination_cents;              // 1
export const WAGERS_CREDITS      = verified.wagers_credits;                  // {PLAY_1X:30, PLAY_2X:60, PLAY_3X:90, MAX_PLAY:500}
export const STANDARD_LINE_PAYS  = verified.standard_symbols;                // per-symbol {3,4,5}
export const DOUBLE_WILD_TABLE   = verified.DOUBLE_WILD_standalone;          // {3,4,5}
export const BONUS_SCATTER_TABLE = verified.BONUS_scatter;                   // {2,3,4,5}

// Feature-flagged rules — engine consumers must respect these switches.
export const RULES = {
  wild_substitutes_all_except_bonus: true,   // LOCKED
  wild_line_multiplier_for_1_or_2:   2,      // LOCKED
  feature_win_multiplier:            3,      // LOCKED (BETO RESPINS wins × 3)
  min_bonus_to_enter_respin:         2,      // LOCKED (2+ enters respin path)
  min_bonus_to_award_free_plays:     3,      // LOCKED (3+ qualifying → 15 free plays)
  free_plays_awarded_on_trigger:     15,     // legacy flat (display fallback only)
  free_plays_tiers:                  { 3: 15, 4: 15, 5: 15 },   // B2: one authoritative rule — 3+ BONUS = 15 free plays
  mixed_3plus_wild_standard:         'NEEDS_VERIFICATION',
  retrigger_rule:                    'NEEDS_VERIFICATION',
  respin_state_transitions:          'NEEDS_VERIFICATION',
  max_play_side_effects:             'NEEDS_VERIFICATION',
};
